import { render, staticRenderFns } from "./MappingHeader.vue?vue&type=template&id=6dbbf910"
import script from "./MappingHeader.vue?vue&type=script&lang=js"
export * from "./MappingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports